
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import CarCardMoveTable from "@/modules/Report/Movements/components/specialComponents/CarCardMoveTable.vue";
  import {httpResource} from "@/resources/http.resource";
  import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";
  import {ICarPopupTables} from "@/modules/Car/interfaces/car-popup-tables.interface";
  import {ICarRequest} from "@/modules/Car/interfaces/car-request.interface";

  @Component({
    components: {
      CarCardMoveTable,
      AppDialog,
    },
  })
  export default class SelectMovementPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'reports', dialogName: 'selectMovementPopup' };
    tableList: IMovementsReport.ICarPopupTableItem[] = [];
    loadingData = false;

    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    async mounted() {
      setTimeout(async () => {
        await this.getData();
      }, 0);
    }

    async getData() {
      this.loadingData = true;
      let asyncAction = async () => {
        const action = ICarRequest.Action.CarsMK;
        const params = {
          command: ICarPopupTables.Command.GetMovements,
          movIds: this.payloadPopup.entity.movIds,
        };
        let {data: { result: response }} = await httpResource.httpAction({ action, params });
        if (response && response.movs) {
          this.tableList = response.movs;
        }
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
      this.loadingData = false;
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
